import React from 'react'

import { Container } from './styles'

function NotFound () {
  return (
    <Container>
      <h1>404</h1>
      <h2>Página não encontrada</h2>
    </Container>
  )
}

export default NotFound
